import { useEffect } from "react";
import { View, ViewProps, ViewStyle } from "react-native";
import Animated, {
    interpolate,
    useAnimatedStyle,
    useSharedValue,
    withDelay,
    withRepeat,
    withTiming,
} from "react-native-reanimated";
import styles from './Circle.jss';

interface CircleProps extends Pick<ViewProps, 'children' | 'style'> {
    delay: number;
    stopAnimation: boolean;
}

const Circle = ({ delay, style }: CircleProps) => {
    const ring = useSharedValue(0);
    const ringStyle = useAnimatedStyle(() => {
        return {
            opacity: 0.9 - ring.value,
            transform: [
                {
                    scale: interpolate(ring.value, [0, 1], [0, 4]),
                },
            ],
        };
    });
    useEffect(() => {
        ring.value = withDelay(
            delay,
            withRepeat(
                withTiming(1, {
                    duration: 1800,
                }),
                -1,
                false,
            )
        );
    }, []);
    return <Animated.View style={[styles.defaultRing, ringStyle, style]} />;
};

interface AnimatedCircleProps extends Omit<ViewProps, 'style'> {
    style?: {
        container?: ViewStyle;
        circle?: ViewStyle
    }
    stopAnimation?: boolean
}

export default function AnimatedCircle({ children, style, stopAnimation = false }: AnimatedCircleProps) {
    return (
        <View style={[styles.container, style.container]}>
            {children}
            <Circle stopAnimation={stopAnimation} style={style.circle} delay={1000} />
        </View>
    );
}